import Button from "@/components/Button";
import { DialogFooter } from "../ui/dialog";
import { BaseModalFooterProps } from "@/types";
import { getDefaultStringValue } from "@/lib/utils";

const ModalFooter = ({
  onClose,
  onConfirm,
  onButtonClick,
  leftButtonText,
  rightButtonText,
  leftButtonVariant = "underline",
  rightButtonVariant = "secondary",
  dataAttributes,
  rightButtonEventClass = "",
  leftButtonEventClass = "",
  isRaiModal = false,
  error,
  errorId,
}: BaseModalFooterProps) => {
  const handleClick = (type: "close" | "confirm", text?: string) => {
    if (onButtonClick) {
      onButtonClick(text);
    }
    if (type === "close" && onClose) {
      onClose(getDefaultStringValue(leftButtonText));
    }
    if (type === "confirm" && onConfirm) {
      onConfirm();
    }
  };

  const handleAdaptiveClose = (e: React.MouseEvent<HTMLButtonElement>) => {
    const buttonText = (e.target as HTMLButtonElement)?.innerText ?? "";
    return isRaiModal ? handleClick("confirm", buttonText) : handleClick("close", buttonText);
  };

  const handleAdaptiveConfirm = (e: React.MouseEvent<HTMLButtonElement>) => {
    const buttonText = (e.target as HTMLButtonElement)?.innerText ?? "";
    return isRaiModal ? handleClick("close", buttonText) : handleClick("confirm", buttonText);
  };

  return (
    <DialogFooter className="flex justify-between items-center sm:justify-between mt-2">
      <Button
        type="button"
        onClick={handleAdaptiveClose}
        variant={leftButtonVariant}
        className={`!focus:outline-none !focus:ring-0 !focus:ring-none !focus:ring-opacity-0 ${leftButtonEventClass}`}
        dataAttributes={{ ...dataAttributes, ["data-action-link-text"]: leftButtonText ?? "" }}
      >
        {leftButtonText}
      </Button>
      <Button
        variant={rightButtonVariant}
        onClick={handleAdaptiveConfirm}
        className={`!w-[fit-content] text-base !h-[3rem] !py-0 !normal-case !font-epilogue !font-bold !px-6 ${rightButtonEventClass}`}
        dataAttributes={{ ...dataAttributes, ["data-action-link-text"]: rightButtonText ?? "" }}
        {...(error && errorId ? { "aria-labelledby": errorId } : {})}
        data-testid="right-button-modal"
      >
        {rightButtonText}
      </Button>
    </DialogFooter>
  );
};

export default ModalFooter;
